import React, { FC, RefObject } from 'react'
import { Direction, REQUEST_TN_DETAILS_STEPS_NAME } from '@services/constants'
import TextInput from '../inputs/text.inputs'
import RadioInput from '../inputs/radio.input'
import { classes } from './__index.utils'
import { RadioList } from '@utils/request'
import MaskedTextInput from '../inputs/textWithValidation.inputs'
import * as utilsList from './__index.utils'
import { formatStrapiText } from '@utils/methods'
import requestForm from '../request.form'
import AddressVoiePublicSection from '@components/ui/addressVoiePublicSection'
import Notification from '@components/ui/notification'
import { joinClasses } from '@utils/styles'
import * as formUtils from '@pages/auth/__index.utils'
import { PHONE_NUMBER_REGEX } from '@pages/auth/profile/__index.utils'
import BlobUploader from '../inputs/azureBlobUploader.input'

const Step2Localisation = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	onFixError,
	isSummaryStep = false,
	// *******
	isAddressOutsideLaval,
	showAdresseBlock,
	inputs,
	onSetInputs,
	formFilesInputs,
	updateFileInput,
	updateUploadedFilesMap,
	onSetErrorFromFileComponent,
	toPrint = false,
	applicantLocation
}) => {
	const {
		whatToDo,

		// **********************
		buildingBatchNumber,
		isSameLocation,
		isLocationOwned,
		ownerFirstName,
		ownerLastName,
		ownerEmail,
		ownerPhoneNumber
	} = formInputs

	const { procurationInput } = formFilesInputs

	const { authUser } = requestForm()

	const addressToShow =
		applicantLocation && applicantLocation.address
			? applicantLocation
			: authUser?.profile?.address

	const radioListWhatToDo: RadioList[] = utilsList.radioListWhatToDo(pageAssets)

	const radioListYesNo: RadioList[] = utilsList.radioListYesNo(pageAssets)
	const radioListAddressOption: RadioList[] =
		utilsList.radioListAddressOption(pageAssets)

	return (
		<>
			{!isSummaryStep && (
				<h4 className={pageUtils.classes.h4}>
					{pageAssets?.request_form_request_location}
				</h4>
			)}

			{(!toPrint ||
				(toPrint && isSameLocation.value == radioListYesNo[0].value)) && (
				<div className={classes.adresseBlock}>
					<div className={pageUtils.classes.fieldsContainer}>
						<div>
							<strong>{pageAssets?.label_address}</strong>
							<br />
							{addressToShow?.address}
							<br />
							{addressToShow?.city}
							{addressToShow?.state ? ` (${addressToShow?.state}) ` : ' '}
							{addressToShow?.postalCode}
							<br />
							{addressToShow?.apartment
								? `${formatStrapiText(pageAssets?.label_apartment_office)} ${
										addressToShow?.apartment
								  }`
								: ''}
						</div>

						{buildingBatchNumber.value && (
							<div>
								<strong>{pageAssets?.lot_number_label}</strong>
								<br />
								{buildingBatchNumber.value}
							</div>
						)}
						{toPrint && <br />}
					</div>
				</div>
			)}

			{/* Question 7 */}

			{(!toPrint ||
				(toPrint && isSameLocation.value == radioListYesNo[0].value)) && (
				<RadioInput
					name={isSameLocation.name}
					label={isSameLocation.label}
					value={isSameLocation.value}
					list={radioListYesNo}
					direction={Direction.vertical}
					hasError={errors!.includes(isSameLocation.name)}
					onChange={(value) => updateInput(isSameLocation.name, value)}
					ref={isSameLocation.ref as RefObject<HTMLInputElement>}
					required={isSameLocation.required}
					hasBackgroundWrapper={true}
					classWrapper={classes.reducedMarginBottom}
					isSummaryStep={isSummaryStep}
				/>
			)}

			{/* Question 8 */}
			{showAdresseBlock == true && (
				<>
					<AddressVoiePublicSection
						label={pageAssets?.request_form_location}
						errors={errors}
						inputs={inputs}
						onFixError={onFixError}
						onSetInputs={onSetInputs}
						isConcernedInfosRequired={
							isSameLocation.value == radioListYesNo[1].value
						}
						showButtonUserLocation={false}
						displayAddressDetails={true}
						requiredFields={[
							'addressOption',
							'addressField',
							'addressLotNumber'
						]}
						subStep={REQUEST_TN_DETAILS_STEPS_NAME.DETAILS_2}
						addressOptions={radioListAddressOption}
						isSummaryStep={isSummaryStep}
					/>

					<br />
				</>
			)}

			{!isSummaryStep &&
				isSameLocation.value == radioListYesNo[0].value &&
				isAddressOutsideLaval && (
					<Notification
						text={
							pageAssets?.request_form_isAddressOutsideLavalMessageShow_notification_label
						}
						type="warning"
						hasHtml
					/>
				)}

			{/* Question 9 */}
			<RadioInput
				name={isLocationOwned.name}
				label={isLocationOwned.label}
				value={isLocationOwned.value}
				list={radioListYesNo}
				direction={Direction.vertical}
				hasError={errors!.includes(isLocationOwned.name)}
				onChange={(value) => updateInput(isLocationOwned.name, value)}
				ref={isLocationOwned.ref as RefObject<HTMLInputElement>}
				required={isLocationOwned.required}
				hasBackgroundWrapper={true}
				classWrapper={classes.reducedMarginBottom}
				isSummaryStep={isSummaryStep}
			/>

			{/* ****** Owner inputs ****** */}
			{isLocationOwned.value == radioListYesNo[1].value && (
				<>
					{!isSummaryStep && (
						<Notification
							text={pageAssets?.request_form_ownerPowerOfAttorney_notification}
							type="info"
							hasHtml
						/>
					)}

					<div
						className={joinClasses([
							classes.fieldsContainer,
							classes.greyBackgroundBlock
						])}
					>
						<TextInput
							id={ownerFirstName.name}
							label={ownerFirstName.label}
							value={ownerFirstName.value}
							onChange={(value: string) =>
								updateInput(ownerFirstName.name, value)
							}
							hasError={errors.includes(ownerFirstName.name)}
							required={ownerFirstName.required}
							ref={ownerFirstName.ref as RefObject<HTMLInputElement>}
							classWrapper={pageUtils?.classes.textFieldContainer}
							maxCharacters={50}
							isSummaryStep={isSummaryStep}
						/>
						<TextInput
							id={ownerLastName.name}
							label={ownerLastName.label}
							value={ownerLastName.value}
							onChange={(value: string) =>
								updateInput(ownerLastName.name, value)
							}
							hasError={errors.includes(ownerLastName.name)}
							required={ownerLastName.required}
							ref={ownerLastName.ref as RefObject<HTMLInputElement>}
							classWrapper={pageUtils?.classes.textFieldContainer}
							maxCharacters={50}
							isSummaryStep={isSummaryStep}
						/>

						<TextInput
							id={ownerEmail.name}
							label={ownerEmail.label}
							value={ownerEmail.value}
							onChange={(value) => updateInput(ownerEmail.name, value)}
							hasError={errors?.includes(ownerEmail.name)}
							type="email"
							onSetError={onFixError}
							schema={formUtils.MASKS.email}
							schemaErrorText={pageAssets?.label_emailErrorText}
							required={ownerEmail.required}
							ref={ownerEmail.ref as RefObject<HTMLInputElement>}
							maxCharacters={100}
							isSummaryStep={isSummaryStep}
						/>
						<MaskedTextInput
							id={ownerPhoneNumber.name}
							label={ownerPhoneNumber.label}
							value={ownerPhoneNumber.value}
							onChange={(value) => updateInput(ownerPhoneNumber.name, value)}
							hasError={errors?.includes(ownerPhoneNumber.name)}
							type="tel"
							min={10}
							max={14}
							mask={formUtils.MASKS.phoneNumber}
							placeholder={formUtils.MASKS.phoneNumber}
							errors={errors ? errors : []}
							setError={onFixError}
							schema={PHONE_NUMBER_REGEX}
							required={ownerPhoneNumber.required}
							ref={ownerPhoneNumber.ref as RefObject<HTMLInputElement>}
							isSummaryStep={isSummaryStep}
						/>
					</div>

					{procurationInput && (
						<>
							<BlobUploader
								name={procurationInput.name}
								subtitle={procurationInput.label}
								description={pageAssets?.request_form_required_documents_description_oneDocument_label}
								required={procurationInput.required}
								files={procurationInput.files}
								uploadedFilesMap={procurationInput.uploadedFilesMap}
								hasError={errors.includes(procurationInput.name)}
								onSetFiles={(files) =>
									updateFileInput(procurationInput.name, files)
								}
								setUploadedFilesMap={(uploadedFilesMap) =>
									updateUploadedFilesMap(
										procurationInput.name,
										uploadedFilesMap
									)
								}
								maxFiles={procurationInput.numberMaxFiles}
								onSetHasError={onSetErrorFromFileComponent}
								isSummary={isSummaryStep}
								toPrint={toPrint}
							/>
							<br />
						</>
					)}
				</>
			)}
		</>
	)
}

export default Step2Localisation
